<template>
  <div class="how-it-works">
    <AppHeader />

    <div class="header">
      <h1>Discover the best framework for you</h1>
    </div>

    <section class="purpose">
      <h4>Purpose</h4>
      <div class="input-section">
        <input type="radio" value="personal" v-model="pickedPurpose" />
        <label for="personal">Personal</label>

        <input type="radio" value="work" v-model="pickedPurpose" />
        <label for="work">Business/Work</label>
      </div>
    </section>

    <!-- Footer -->
    <footer>
      <div class="container">
        <div class="icon-text">
          <i class="fa fa-2x fa-envelope" alt="icon email"></i>
          <a
            style="color: #fff; font-size: 1.7rem; margin-left: 10px"
            href="mailto:hello@usetaski.com"
            >hello@usetaski.com</a
          >
        </div>
        <div class="socialShare">
          <span class="socialIcons">
            <a
              href="https://twitter.com/intent/tweet?url=https://mohitkhare.me&text=Make better decisions"
              target="_blank"
            >
              <i
                style="color: #fff"
                class="fab fa-2x fa-twitter"
                aria-hidden="true"
              ></i>
            </a>
          </span>

          <span class="socialIcons">
            <a
              href="https://www.facebook.com/sharer/sharer.php?u=mohitkhare.me"
              target="_blank"
            >
              <i
                style="color: #fff"
                class="fab fa-2x fa-facebook-f"
                aria-hidden="true"
                target="_blank"
              ></i>
            </a>
          </span>
          <span class="socialIcons">
            <a
              target="_blank"
              style="color: #fff"
              href="https://www.linkedin.com/shareArticle?mini=true&url=https://mohitkhare.me/"
              onclick="window.open(this.href, 'width=550,height=435');return false;"
            >
              <i class="fab fa-2x fa-linkedin-in" aria-hidden="true"></i>
            </a>
          </span>
        </div>
        <p style="font-size: 1.2rem; font-style: bold">
          Made with
          <i style="color: #fff" class="fas fa-heart heartIcon"></i> by
          <a style="color: #fff" href="https://mohitkhare.me" target="blank"
            >Mohit</a
          >
        </p>

        <p>
          Copyright @
          <a style="color: white" href="https://usetaski.com">Usetaski</a> -
          2021
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
import AppHeader from "@/components/AppHeader.vue";
import AppFooter from "@/components/AppFooter.vue";

export default {
  name: "Discover",
  components: {
    AppHeader,
    AppFooter,
  },
  created() {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 200);
  },
  data() {
    return {
      pickedPurpose: "",
    };
  },
};
</script>

<style>
.purpose {
  margin: 20px;
}

.purpose .input-section input {
  font-size: 20px;
  margin-right: 10px;
}

.purpose .input-section label {
  font-size: 20px;
  margin-right: 40px;
}
</style>